/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardTileSummary { 
    activeSessions?: number;
    totalTicketsToday?: number;
    todaysEarnings?: number;
    failedPayments?: number;
    monthEarnings?: number;
    yearEarnings?: number;
}

